import React from 'react';

interface TrackingFunctions {
  onClassificationSelected: () => void;
  onRoleTitleUpdated: () => void;
  onLocationSelected: () => void;
  onProductLinkClicked: () => void;
  onPriceQuery: (
    locationId: number,
    classification: string,
    subClassification: string,
  ) => void;
}

const TrackingContext = React.createContext<TrackingFunctions>({
  onClassificationSelected: () => {},
  onLocationSelected: () => {},
  onProductLinkClicked: () => {},
  onRoleTitleUpdated: () => {},
  onPriceQuery: () => {},
});

export { TrackingContext };
